/* __next_internal_client_entry_do_not_use__ iconButton,iconButtonSpinner,iconButtonIcon,ICON_BUTTON_ELEMENT_TAG,IconButton auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { button, buttonSpinner } from "@air/primitive-button";
import { Spinner } from "@air/primitive-spinner";
import { VisuallyHidden } from "@air/primitive-visually-hidden";
import { tailwindVariants } from "@air/tailwind-variants";
import classNames from "classnames";
import { forwardRef } from "react";
export const iconButton = tailwindVariants({
    extend: button,
    base: "px-0",
    variants: {
        size: {
            "extra-small": "h-4 w-4 px-0 text-12",
            small: "h-6 w-6 px-0 text-12",
            medium: "h-8 w-8 px-0 text-14",
            large: "h-10 w-10 px-0 text-16",
            "extra-large": "h-12 w-12 px-0 text-16"
        }
    }
});
export const iconButtonSpinner = tailwindVariants({
    extend: buttonSpinner
});
export const iconButtonIcon = tailwindVariants({
    base: "block h-4 w-4",
    variants: {
        size: {
            "extra-small": "h-3 w-3",
            small: "h-4 w-4",
            medium: "h-4 w-4",
            large: "h-5 w-5",
            "extra-large": "h-6 w-6"
        }
    }
});
export const ICON_BUTTON_ELEMENT_TAG = "button";
export const IconButton = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { appearance = "filled", className, color = "blue", isLoading, label, size = "medium", type = "button", ...restOfProps } = param;
    const childrenNode = "children" in restOfProps ? restOfProps.children : /*#__PURE__*/ _jsx(restOfProps.icon, {
        className: iconButtonIcon({
            size
        })
    });
    return /*#__PURE__*/ _jsx("button", {
        className: classNames(iconButton({
            appearance,
            color,
            size,
            class: className
        }), isLoading ? "cursor-not-allowed" : "cursor-pointer"),
        ref: forwardedRef,
        type: type,
        ...restOfProps,
        children: isLoading ? /*#__PURE__*/ _jsxs("div", {
            role: "status",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
                    children: /*#__PURE__*/ _jsx(Spinner, {
                        className: iconButtonSpinner({
                            size
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(VisuallyHidden, {
                    children: "Loading..."
                }),
                /*#__PURE__*/ _jsx("div", {
                    "aria-hidden": true,
                    className: "invisible opacity-0",
                    children: childrenNode
                })
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                label ? /*#__PURE__*/ _jsx(VisuallyHidden, {
                    children: label
                }) : label,
                childrenNode
            ]
        })
    });
});
IconButton.displayName = "IconButton";
